/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  const CART_EST_THRESHOLD = 2;

  async function updateCartEstShipping() {
    let cart;
    try {
      const res = await fetch('/cart.js');
      cart = await res.json();
    } catch(e) { return; }

    if (!cart.items || cart.items.length === 0) return;

    const items = cart.items;
    const handles = [...new Set(items.map(i => i.handle))];

    const metafields = {};
    await Promise.all(handles.map(async (handle) => {
      try {
        const res = await fetch(`/products/${handle}?view=est-data`);
        const text = await res.text();
        const data = JSON.parse(text.trim());
        Object.assign(metafields, data);
      } catch(e) {}
    }));

    items.forEach(function(item) {
      const mf = metafields[item.variant_id] || { est: '', zaiko: 999 };
      const expected = (mf.zaiko <= CART_EST_THRESHOLD && mf.est) ? mf.est : '';
      const current = item.properties ? (item.properties['_est_shipping'] || '') : '';
      if (current === expected) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, properties: { '_est_shipping': expected } })
      });
    });
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    }
    updateCartEstShipping();
  });

  document.addEventListener('theme:cart:init', function(e) {
    console.log('theme:cart:init');
    console.log(e);
    updateCartEstShipping();
  });

  var cartDrawerEl = document.querySelector('[data-drawer="drawer-cart"]');
  if (cartDrawerEl) {
    cartDrawerEl.addEventListener('theme:drawer:open', updateCartEstShipping);
  }

  if (window.location.pathname === '/cart') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateCartEstShipping);
    } else {
      updateCartEstShipping();
    }
  }

  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });
  document.addEventListener('theme:resize', e => { console.log(e); });

})();
